"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = require('./menuIcon.scss');

var MenuIcon = function MenuIcon(_ref) {
  var section = _ref.section;
  return section.icon ? _react["default"].createElement("span", {
    className: styles['menu-icon']
  }, _react["default"].createElement("img", {
    src: section.icon
  })) : null;
};

MenuIcon.propTypes = {};
MenuIcon.defaultProps = {};
var _default = MenuIcon;
exports["default"] = _default;